import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function hasStatsConsent() {
  try { return JSON.parse(localStorage.getItem("fsbe-consent") || "{}").stats === true; } catch { return false; }
}

export function track(type, path = "", ref_id = "") {
  if (!hasStatsConsent()) return;
  http.post("/track", { type, path, ref_id }).catch(() => {});
}
